import styled from 'styled-components';
import ChatCodeBlock from './ChatCodeBlock';

const INLINE_CODE_FONT_SIZE = '0.85em';

const ICON_AREA_WIDTH = 32;

const FullWidthBreakout = styled.div`
  width: 100cqi;
  margin-left: calc((100% - ${ICON_AREA_WIDTH}px - 100cqi) / 2);
  margin-right: calc((100% + ${ICON_AREA_WIDTH}px - 100cqi) / 2);
`;

const InlineCode = styled.code`
  font-size: ${INLINE_CODE_FONT_SIZE};
  overflow-wrap: break-word;
`;

type Props = {
  children?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  [x: string]: any;
};

const CodeBlock = ({ children, className, fullWidth, ...props }: Props) => {
  const language = className?.replace('language-', '');
  const codeContent = children as string;
  const multilineCode = codeContent?.replace(/\n\s*$/, '');
  const isMultiline =
    multilineCode?.split('\n').filter((line) => !!line).length > 1;

  if (isMultiline) {
    const block = <ChatCodeBlock language={language} value={multilineCode} />;

    return fullWidth ? <FullWidthBreakout>{block}</FullWidthBreakout> : block;
  }

  return (
    <InlineCode className={className} {...props}>
      {children}
    </InlineCode>
  );
};

export default CodeBlock;
